export interface ErrorResponse {
  code?: number | null;
  detail?: string | null;
  domain?: string | null;
  error?: string | null;
  formatted?: string | null;
  msg?: string | null;
  rpc_code?: number | null;
}

export interface OtherErrorResponse {
  code?: number | null;
  detail?: string | null;
  domain?: string | null;
  error?: {
    code: string;
    errors: string[];
    message: string;
  };
  formatted?: string | null;
  msg?: string | null;
  rpc_code?: number | null;
}

export const isErrorResponse = (
  response: unknown,
): response is ErrorResponse => {
  const castedResponse = response as ErrorResponse;

  if (castedResponse.error != null) return true;
  else if (castedResponse.code && castedResponse.code >= 400) return true;
  return false;
};

export const isOtherErrorResponse = (
  response: unknown,
): response is OtherErrorResponse => {
  const castedResponse = response as OtherErrorResponse;

  if (typeof castedResponse.error === 'object') return true;
  else if (castedResponse.code && castedResponse.code >= 400) return true;
  return false;
};

export interface StatusResponse {
  status: string;
}
export interface IdResponse {
  id: string;
}
